export class CancelPlayerReadyRequest {
    static Message = 'CancelPlayerReadyRequest';
}

export class CancelPlayerReadyResponse {
    static Message = 'CancelPlayerReadyResponse';

    public playerId: string;

    constructor(playerId: string) {
        this.playerId = playerId;
    }
}
